import React, {Fragment} from "react";
import styles from './Meet.module.css';

const Meet2 = (props) => {
    return (
        <Fragment>
            <div className={styles.content}>
                <p className={styles.about}>{props.about}</p>
                <img src={props.photo} alt="Team member"/>
    
            </div>
        </Fragment>
    )
}

export default Meet2;